import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import Select from "react-select";
import Chart from "react-apexcharts";
import SiteWrapper from "../../SiteWrapper.react";
import axios from "axios";
import * as conf from "../../config/config";

const GpsPatiosCirculacion = () => {
  const [gpsList, setGpsList] = useState([]);
  const [gpsDisponibles, setGpsDisponibles] = useState([]);
  const [gpsSeleccionado, setGpsSeleccionado] = useState(null);
  const clearTimerRef = useRef(null);
  
  // Filtros
  const [localidadOpcion, setLocalidadOpcion] = useState({ value: 0, label: "Todos" });
  const [paisOpcion, setPaisOpcion] = useState({ value: 0, label: "Todos" });
  const [plataformaOpcion, setPlataformaOpcion] = useState({ value: 0, label: "Todos" });
  
  // Buscador de transportistas
  const [busquedaTransportista, setBusquedaTransportista] = useState("");
  
  // Paginación para transportistas
  const [paginaActual, setPaginaActual] = useState(1);
  const transportistasPorPagina = 20;

  // Cargar datos inicial
  useEffect(() => {
    getfuntion("get", [], "", "gps/dash", "patios_circulacion");
    cargarGpsDisponibles();
    startAutoRefresh();

    // Cleanup al desmontar el componente
    return () => {
      if (clearTimerRef.current) {
        clearInterval(clearTimerRef.current);
        clearTimerRef.current = null;
      }
    };
  }, []);

  // Función para iniciar recarga automática cada minuto
  const startAutoRefresh = () => {
    if (clearTimerRef.current) {
      clearInterval(clearTimerRef.current);
      clearTimerRef.current = null;
    }

    clearTimerRef.current = setInterval(() => {
      getfuntion("get", [], "", "gps/dash", "patios_circulacion");
    }, 60000); // 60 segundos
  };

  // Memoizar opciones de filtros para evitar recalcular en cada render
  const opcionesFiltros = useMemo(() => {
    const localidades = new Set();
    const paises = new Set();
    const plataformas = new Set();

    gpsList.forEach((gps) => {
      if (gps.corredor && gps.corredor !== 'Sin corredor') {
        localidades.add(gps.corredor);
      }
      if (gps.pais && gps.pais !== 'Sin país') {
        paises.add(gps.pais);
      }
      if (gps.plataforma && gps.plataforma !== 'Sin plataforma') {
        plataformas.add(gps.plataforma);
      }
    });

    return {
      localidadOpciones: [
        { value: 0, label: "Todos" },
        ...Array.from(localidades).map(item => ({ value: item, label: item }))
      ],
      paisOpciones: [
        { value: 0, label: "Todos" },
        ...Array.from(paises).map(item => ({ value: item, label: item }))
      ],
      plataformaOpciones: [
        { value: 0, label: "Todos" },
        ...Array.from(plataformas).map(item => ({ value: item, label: item }))
      ]
    };
  }, [gpsList]);

  // Memoizar datos filtrados
  const gpsListFiltrados = useMemo(() => {
    let gpssTemp = [...gpsList];

    if (localidadOpcion.value) {
      gpssTemp = gpssTemp.filter(g => g.corredor === localidadOpcion.label);
    }
    if (paisOpcion.value) {
      gpssTemp = gpssTemp.filter(g => g.pais === paisOpcion.label);
    }
    if (plataformaOpcion.value) {
      gpssTemp = gpssTemp.filter(g => g.plataforma === plataformaOpcion.label);
    }

    return gpssTemp;
  }, [gpsList, localidadOpcion, paisOpcion, plataformaOpcion]);

  // Función optimizada para limpiar filtros
  const limpiarFiltros = useCallback(() => {
    const filtrosDefault = { value: 0, label: "Todos" };
    setLocalidadOpcion(filtrosDefault);
    setPaisOpcion(filtrosDefault);
    setPlataformaOpcion(filtrosDefault);
  }, []);

  const getfuntion = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "") => {
    Crud_Catalogos(catalogo, "home", metodo, id, obj, "", stateVar, "", [])
      .then((returnVal) => {
        if (metodo === "get" && stateVar === "patios_circulacion") {
          if (returnVal) {
            console.log("Datos recibidos del backend:", returnVal);
            
            // Procesar datos una sola vez
            const fechaActual = new Date().getTime();
            const gpsListProcesada = returnVal.map(gps => {
              let diasSinReporte = null;
              let color = null;
              let categoriaDias = null;

              // Para GPS "Por Recuperar", usar end_date; para otros, usar deviceactivity
              const fechaReferencia = gps.gpsEstatus === 'Por Recuperar' ? gps.endDate : gps.deviceactivity;

              if (fechaReferencia) {
                const fechaDevice = new Date(fechaReferencia).getTime();
                diasSinReporte = Math.round((fechaActual - fechaDevice) / (1000 * 60 * 60 * 24));
                
                if (gps.gpsEstatus !== 'Instalado') {
                  if (diasSinReporte <= 2) {
                    color = 'green';
                    categoriaDias = '0-2 días';
                  } else if (diasSinReporte <= 10) {
                    color = 'yellow';
                    categoriaDias = '3-10 días';
                  } else {
                    color = 'red';
                    categoriaDias = 'Más de 10 días';
                  }
                }
              } else {
                if (gps.gpsEstatus !== 'Instalado') {
                  color = 'gray';
                  categoriaDias = 'Sin reporte';
                }
              }

              return {
                ...gps,
                diasSinReporte,
                color,
                categoriaDias
              };
            });

            console.log("Datos procesados con colores:", gpsListProcesada);
            setGpsList(gpsListProcesada);
          }
        }
      })
      .catch((err) => {
        console.error("Error al cargar datos:", err);
      });
  };

  // Cargar GPS disponibles (todos los GPS para poder filtrar)
  const cargarGpsDisponibles = () => {
    Crud_Catalogos("gps", "home", "get", "", [], "", "", "", [])
      .then((returnVal) => {
        if (returnVal) {
          console.log("Todos los GPS:", returnVal); // Debug
          // Filtrar solo GPS que NO están en patios (patios = 0 o null o false)
          const gpsNoPatios = returnVal.filter(gps => !gps.patios || gps.patios === 0);
          console.log("GPS disponibles para patios:", gpsNoPatios); // Debug
          
          const opciones = gpsNoPatios.map(gps => ({
            value: gps.id,
            label: `${gps.nombre} - ${gps.imei}`
          }));
          setGpsDisponibles(opciones);
        }
      })
      .catch((err) => {
        console.error("Error al cargar GPS disponibles:", err);
      });
  };

  // Agregar GPS a patios (patios = true)
  const agregarGpsPatios = () => {
    if (!gpsSeleccionado) {
      alert("Selecciona un GPS");
      return;
    }

    console.log("Intentando agregar GPS:", gpsSeleccionado); // Debug

    const token = sessionStorage.getItem('tok');
    
    axios.put(`${conf.api_raiz}gps/patios/${gpsSeleccionado.value}?patios=true`, null, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      console.log("Respuesta del servidor:", response.data); // Debug
      alert("GPS agregado a patios correctamente");
      setGpsSeleccionado(null);
      // Recargar datos
      getfuntion("get", [], "", "gps/dash", "patios_circulacion");
      cargarGpsDisponibles();
    })
    .catch(error => {
      console.error('Error completo:', error); // Debug más detallado
      console.error('Respuesta del error:', error.response?.data); // Debug
      alert(`Error al agregar GPS a patios: ${error.response?.data || error.message}`);
    });
  };

  // Eliminar GPS de patios (patios = false)
  const eliminarGpsPatios = (gpsId, gpsNombre) => {
    if (!window.confirm(`¿Estás seguro de eliminar ${gpsNombre} de patios?`)) {
      return;
    }

    const token = sessionStorage.getItem('tok');
    
    axios.put(`${conf.api_raiz}gps/patios/${gpsId}?patios=false`, null, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      alert("GPS eliminado de patios correctamente");
      // Recargar datos
      getfuntion("get", [], "", "gps/dash", "patios_circulacion");
      cargarGpsDisponibles();
    })
    .catch(error => {
      console.error('Error al eliminar GPS de patios:', error);
      alert("Error al eliminar GPS de patios");
    });
  };

  // Memoizar cálculos de datos para evitar recalcular en cada render
  const datosCalculados = useMemo(() => {
    const disponibles = gpsListFiltrados.filter(g => g.gpsEstatus === 'Disponible');
    const instalados = gpsListFiltrados.filter(g => g.gpsEstatus === 'Instalado');
    const porRecuperar = gpsListFiltrados.filter(g => g.gpsEstatus === 'Por Recuperar');

    // Calcular datos de disponibles
    const disponiblesData = {
      total: disponibles.length,
      porDias: {
        verde: disponibles.filter(g => g.color === 'green').length,
        amarillo: disponibles.filter(g => g.color === 'yellow').length,
        rojo: disponibles.filter(g => g.color === 'red').length,
        sinReporte: disponibles.filter(g => g.color === 'gray').length
      },
      porLocalidad: {}
    };

    disponibles.forEach(gps => {
      const loc = gps.corredor || 'Sin localidad';
      if (!disponiblesData.porLocalidad[loc]) {
        disponiblesData.porLocalidad[loc] = { total: 0, verde: 0, amarillo: 0, rojo: 0, gris: 0 };
      }
      disponiblesData.porLocalidad[loc].total++;
      if (gps.color === 'green') disponiblesData.porLocalidad[loc].verde++;
      if (gps.color === 'yellow') disponiblesData.porLocalidad[loc].amarillo++;
      if (gps.color === 'red') disponiblesData.porLocalidad[loc].rojo++;
      if (gps.color === 'gray') disponiblesData.porLocalidad[loc].gris++;
    });

    // Calcular datos de instalados
    const instaladosData = {
      total: instalados.length,
      porPlataforma: {}
    };

    instalados.forEach(gps => {
      const plat = gps.plataforma || 'Sin plataforma';
      instaladosData.porPlataforma[plat] = (instaladosData.porPlataforma[plat] || 0) + 1;
    });

    // Calcular datos de por recuperar
    const porRecuperarData = {
      total: porRecuperar.length,
      porDias: {
        verde: porRecuperar.filter(g => g.color === 'green').length,
        amarillo: porRecuperar.filter(g => g.color === 'yellow').length,
        rojo: porRecuperar.filter(g => g.color === 'red').length,
        sinReporte: porRecuperar.filter(g => g.color === 'gray').length
      },
      porTransportista: {}
    };

    porRecuperar.forEach(gps => {
      const trans = gps.transportista || 'Sin transportista';
      if (!porRecuperarData.porTransportista[trans]) {
        porRecuperarData.porTransportista[trans] = { total: 0, verde: 0, amarillo: 0, rojo: 0, gris: 0 };
      }
      porRecuperarData.porTransportista[trans].total++;
      if (gps.color === 'green') porRecuperarData.porTransportista[trans].verde++;
      if (gps.color === 'yellow') porRecuperarData.porTransportista[trans].amarillo++;
      if (gps.color === 'red') porRecuperarData.porTransportista[trans].rojo++;
      if (gps.color === 'gray') porRecuperarData.porTransportista[trans].gris++;
    });

    // Ordenar transportistas por total de unidades (mayor a menor)
    const transportistasOrdenados = Object.entries(porRecuperarData.porTransportista)
      .sort((a, b) => b[1].total - a[1].total);

    // Filtrar por búsqueda si hay texto
    const transportistasFiltrados = busquedaTransportista 
      ? transportistasOrdenados.filter(([nombre]) => 
          nombre.toLowerCase().includes(busquedaTransportista.toLowerCase())
        )
      : transportistasOrdenados;

    // Paginación
    const totalPaginas = Math.ceil(transportistasFiltrados.length / transportistasPorPagina);
    const inicio = (paginaActual - 1) * transportistasPorPagina;
    const fin = inicio + transportistasPorPagina;
    const transportistasPaginados = transportistasFiltrados.slice(inicio, fin);

    return {
      disponibles: disponiblesData,
      instalados: instaladosData,
      porRecuperar: {
        ...porRecuperarData,
        transportistasOrdenados,
        transportistasFiltrados,
        transportistasPaginados,
        totalPaginas,
        paginaActual
      }
    };
  }, [gpsListFiltrados, busquedaTransportista, paginaActual]);

  return (
    <SiteWrapper>
      <div className="container-fluid">
        {/* Título */}
        <div className="row justify-content-center" style={{ margin: "16px" }}>
          <div className="col-12 text-center">
            <h1>Circulación de activos - GPS Patios</h1>
            <p className="text-muted">Dashboard de monitoreo de GPS</p>
          </div>
        </div>

        {/* Filtros */}
        <div className="row mb-4">
          <div className="col-md-3">
            <div className="form-group">
              <label><strong>Localidad</strong></label>
              <Select
                value={localidadOpcion}
                onChange={setLocalidadOpcion}
                options={opcionesFiltros.localidadOpciones}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label><strong>País</strong></label>
              <Select
                value={paisOpcion}
                onChange={setPaisOpcion}
                options={opcionesFiltros.paisOpciones}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label><strong>Plataforma</strong></label>
              <Select
                value={plataformaOpcion}
                onChange={setPlataformaOpcion}
                options={opcionesFiltros.plataformaOpciones}
              />
            </div>
          </div>
          <div className="col-md-3 d-flex align-items-end">
            <button 
              className="btn btn-secondary btn-block"
              onClick={limpiarFiltros}
            >
              Limpiar filtros
            </button>
          </div>
        </div>
        
        {/* Resumen general */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5>Resumen General</h5>
                <div className="row text-center">
                  <div className="col-md-3">
                    <h3 className="text-success">{datosCalculados.disponibles.total}</h3>
                    <p>Disponibles</p>
                  </div>
                  <div className="col-md-3">
                    <h3 className="text-primary">{datosCalculados.instalados.total}</h3>
                    <p>Instalados</p>
                  </div>
                  <div className="col-md-3">
                    <h3 className="text-warning">{datosCalculados.porRecuperar.total}</h3>
                    <p>Por Recuperar</p>
                  </div>
                  <div className="col-md-3">
                    <h3 className="text-info">{gpsListFiltrados.length}</h3>
                    <p>Total GPS Patios</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* Dashboard principal - 3 columnas */}
        <div className="row">
          {/* COLUMNA 1: DISPONIBLES */}
          <div className="col-md-4">
            <div className="card mb-4 shadow-sm">
              <div className="card-header bg-success text-white">
                <h4 className="mb-0">
                  <i className="fe fe-check-circle mr-2"></i>
                  Disponibles
                </h4>
              </div>
              <div className="card-body">
                <h2 className="text-center mb-3">{datosCalculados.disponibles.total}</h2>
                
                {/* Gráfica de dona - por días */}
                {datosCalculados.disponibles.total > 0 ? (
                  <>
                    <Chart
                      series={[
                        datosCalculados.disponibles.porDias.verde,
                        datosCalculados.disponibles.porDias.amarillo,
                        datosCalculados.disponibles.porDias.rojo,
                        datosCalculados.disponibles.porDias.sinReporte
                      ]}
                      options={{
                        chart: { type: 'donut' },
                        labels: ['0-2 días', '3-10 días', 'Más de 10 días', 'Sin reporte'],
                        colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                        legend: { position: 'bottom' },
                        dataLabels: {
                          enabled: true,
                          formatter: function (val) {
                            return val.toFixed(0) + "%"
                          }
                        }
                      }}
                      type="donut"
                      height={250}
                    />

                    {/* Gráfica de barras horizontales - por localidad */}
                    {Object.keys(datosCalculados.disponibles.porLocalidad).length > 0 && (() => {
                      // Ordenar localidades por total de GPS (mayor a menor)
                      const localidadesOrdenadas = Object.entries(datosCalculados.disponibles.porLocalidad)
                        .sort((a, b) => b[1].total - a[1].total);
                      
                      return (
                        <div className="mt-4">
                          <h6>Por Localidad</h6>
                          <Chart
                            series={[
                              {
                                name: '0-2 días',
                                data: localidadesOrdenadas.map(([, data]) => data.verde)
                              },
                              {
                                name: '3-10 días',
                                data: localidadesOrdenadas.map(([, data]) => data.amarillo)
                              },
                              {
                                name: 'Más de 10 días',
                                data: localidadesOrdenadas.map(([, data]) => data.rojo)
                              },
                              {
                                name: 'Sin reporte',
                                data: localidadesOrdenadas.map(([, data]) => data.gris)
                              }
                            ]}
                            options={{
                              chart: { 
                                type: 'bar', 
                                stacked: true,
                                toolbar: { show: false }
                              },
                              plotOptions: {
                                bar: { 
                                  horizontal: true,
                                  barHeight: '60%',
                                  dataLabels: {
                                    position: 'center'
                                  }
                                }
                              },
                              xaxis: {
                                categories: localidadesOrdenadas.map(([nombre]) => nombre),
                                labels: {
                                  style: {
                                    fontSize: '11px'
                                  }
                                }
                              },
                              yaxis: {
                                labels: {
                                  style: {
                                    fontSize: '11px'
                                  },
                                  maxWidth: 120
                                }
                              },
                              colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                              legend: {
                                position: 'bottom',
                                fontSize: '11px'
                              }
                            }}
                            type="bar"
                            height={localidadesOrdenadas.length * 35}
                          />
                        </div>
                      );
                    })()}
                  </>
                ) : (
                  <p className="text-center text-muted">No hay GPS disponibles</p>
                )}
              </div>
            </div>
          </div>

          {/* COLUMNA 2: INSTALADOS */}
          <div className="col-md-4">
            <div className="card mb-4 shadow-sm">
              <div className="card-header bg-primary text-white">
                <h4 className="mb-0">
                  <i className="fe fe-map-pin mr-2"></i>
                  Instalados
                </h4>
              </div>
              <div className="card-body">
                <h1 className="display-3 text-primary text-center">{datosCalculados.instalados.total}</h1>
                <p className="text-muted text-center">GPS activos</p>

                {/* Gráfica de dona - por plataforma */}
                {datosCalculados.instalados.total > 0 && Object.keys(datosCalculados.instalados.porPlataforma).length > 0 && (
                  <div className="mt-4">
                    <h6>Plataformas</h6>
                    <Chart
                      series={Object.values(datosCalculados.instalados.porPlataforma)}
                      options={{
                        chart: { type: 'donut' },
                        labels: Object.keys(datosCalculados.instalados.porPlataforma),
                        legend: { position: 'bottom' },
                        dataLabels: {
                          enabled: true,
                          formatter: function (val) {
                            return val.toFixed(1) + "%"
                          }
                        }
                      }}
                      type="donut"
                      height={300}
                    />

                    {/* Lista de plataformas con porcentajes y totales */}
                    <div className="mt-3">
                      <ul className="list-unstyled">
                        {Object.entries(datosCalculados.instalados.porPlataforma)
                          .sort((a, b) => b[1] - a[1])
                          .map(([plataforma, cantidad]) => {
                            const porcentaje = ((cantidad / datosCalculados.instalados.total) * 100).toFixed(1);
                            return (
                              <li key={plataforma} className="mb-2 d-flex justify-content-between">
                                <span>• {plataforma}</span>
                                <strong>{porcentaje}% ({cantidad})</strong>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* COLUMNA 3: POR RECUPERAR */}
          <div className="col-md-4">
            <div className="card mb-4 shadow-sm">
              <div className="card-header bg-warning text-dark">
                <h4 className="mb-0">
                  <i className="fe fe-alert-triangle mr-2"></i>
                  Por recuperar
                </h4>
              </div>
              <div className="card-body">
                <h2 className="text-center mb-3">{datosCalculados.porRecuperar.total}</h2>
                
                {/* Gráfica de dona - por días */}
                {datosCalculados.porRecuperar.total > 0 ? (
                  <>
                    <Chart
                      series={[
                        datosCalculados.porRecuperar.porDias.verde,
                        datosCalculados.porRecuperar.porDias.amarillo,
                        datosCalculados.porRecuperar.porDias.rojo,
                        datosCalculados.porRecuperar.porDias.sinReporte
                      ]}
                      options={{
                        chart: { type: 'donut' },
                        labels: ['0-2 días', '3-10 días', 'Más de 10 días', 'Sin reporte'],
                        colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                        legend: { position: 'bottom' },
                        dataLabels: {
                          enabled: true,
                          formatter: function (val) {
                            return val.toFixed(0) + "%"
                          }
                        }
                      }}
                      type="donut"
                      height={250}
                    />

                    {/* Gráfica de barras horizontales - por transportista */}
                    {datosCalculados.porRecuperar.transportistasOrdenados.length > 0 && (
                      <div className="mt-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h6>Por Transportista</h6>
                          <small className="text-muted">
                            Página {datosCalculados.porRecuperar.paginaActual} de {datosCalculados.porRecuperar.totalPaginas} 
                            ({datosCalculados.porRecuperar.transportistasFiltrados.length} total)
                          </small>
                        </div>
                        
                        {/* Buscador */}
                        <div className="mb-3">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Buscar transportista..."
                            value={busquedaTransportista}
                            onChange={(e) => {
                              setBusquedaTransportista(e.target.value);
                              setPaginaActual(1); // Reset a página 1 al buscar
                            }}
                          />
                        </div>
                        
                        {/* Mensaje cuando no se encuentra */}
                        {busquedaTransportista && datosCalculados.porRecuperar.transportistasFiltrados.length === 0 ? (
                          <div className="text-center text-muted py-4">
                            <i className="fe fe-search mb-2" style={{fontSize: '2rem'}}></i>
                            <p>Transportista no localizado</p>
                            <small>No se encontró "{busquedaTransportista}" en el dashboard</small>
                          </div>
                        ) : datosCalculados.porRecuperar.transportistasPaginados.length > 0 && (
                          <>
                            <Chart
                              series={[
                                {
                                  name: '0-2 días',
                                  data: datosCalculados.porRecuperar.transportistasPaginados.map(([, data]) => data.verde)
                                },
                                {
                                  name: '3-10 días',
                                  data: datosCalculados.porRecuperar.transportistasPaginados.map(([, data]) => data.amarillo)
                                },
                                {
                                  name: 'Más de 10 días',
                                  data: datosCalculados.porRecuperar.transportistasPaginados.map(([, data]) => data.rojo)
                                },
                                {
                                  name: 'Sin reporte',
                                  data: datosCalculados.porRecuperar.transportistasPaginados.map(([, data]) => data.gris)
                                }
                              ]}
                              options={{
                                chart: { 
                                  type: 'bar', 
                                  stacked: true,
                                  toolbar: { show: false }
                                },
                                plotOptions: {
                                  bar: { 
                                    horizontal: true,
                                    barHeight: '60%',
                                    dataLabels: {
                                      position: 'center'
                                    }
                                  }
                                },
                                xaxis: {
                                  categories: datosCalculados.porRecuperar.transportistasPaginados.map(([nombre]) => nombre),
                                  labels: {
                                    style: {
                                      fontSize: '11px'
                                    }
                                  }
                                },
                                yaxis: {
                                  labels: {
                                    style: {
                                      fontSize: '11px'
                                    },
                                    maxWidth: 120
                                  }
                                },
                                colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                                legend: {
                                  position: 'bottom',
                                  fontSize: '11px'
                                }
                              }}
                              type="bar"
                              height={Math.max(300, datosCalculados.porRecuperar.transportistasPaginados.length * 35)}
                            />
                            
                            {/* Controles de paginación */}
                            {datosCalculados.porRecuperar.totalPaginas > 1 && (
                              <div className="d-flex justify-content-center align-items-center mt-3">
                                {paginaActual > 1 && (
                                  <button 
                                    className="btn btn-sm btn-outline-secondary me-2" 
                                    onClick={() => setPaginaActual(paginaActual - 1)}
                                  >
                                    -
                                  </button>
                                )}
                                <span className="mx-3">
                                  {paginaActual}
                                </span>
                                {paginaActual < datosCalculados.porRecuperar.totalPaginas && (
                                  <button 
                                    className="btn btn-sm btn-outline-secondary ms-2" 
                                    onClick={() => setPaginaActual(paginaActual + 1)}
                                  >
                                    +
                                  </button>
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <p className="text-center text-muted">No hay GPS por recuperar</p>
                )}
              </div>
            </div>
          </div>
        </div>


      </div>
    </SiteWrapper>
  );
};

export default GpsPatiosCirculacion;